// File Path: web/frontend/src/constants/UI.js

/**
 * UI-related constants for the application
 * Includes timeouts, delays, and other UI interaction values
 */

// Success message display durations (in milliseconds)
export const SUCCESS_MESSAGE_DISPLAY_DURATION = 2000; // 2 seconds
export const SUCCESS_MESSAGE_REDIRECT_DELAY = 2000; // 2 seconds before redirect

// Loading and transition durations
export const DEFAULT_LOADING_DELAY = 300; // 300ms
export const SLOW_TRANSITION_DURATION = 500; // 500ms
export const FAST_TRANSITION_DURATION = 200; // 200ms

// Debounce and throttle values
export const DEFAULT_DEBOUNCE_DELAY = 300; // 300ms
export const SEARCH_DEBOUNCE_DELAY = 500; // 500ms
export const RESIZE_THROTTLE_DELAY = 100; // 100ms

// Toast notification durations
export const TOAST_SHORT_DURATION = 3000; // 3 seconds
export const TOAST_MEDIUM_DURATION = 5000; // 5 seconds
export const TOAST_LONG_DURATION = 8000; // 8 seconds

// Animation durations
export const MODAL_ANIMATION_DURATION = 300; // 300ms
export const DROPDOWN_ANIMATION_DURATION = 200; // 200ms
export const FADE_ANIMATION_DURATION = 150; // 150ms

// Polling intervals
export const DEFAULT_POLL_INTERVAL = 5000; // 5 seconds
export const FAST_POLL_INTERVAL = 2000; // 2 seconds
export const SLOW_POLL_INTERVAL = 10000; // 10 seconds

// Scroll and pagination
export const INFINITE_SCROLL_THRESHOLD = 100; // pixels from bottom
export const SMOOTH_SCROLL_DURATION = 500; // 500ms

// Form validation
export const VALIDATION_DEBOUNCE_DELAY = 500; // 500ms
export const PASSWORD_STRENGTH_CHECK_DELAY = 300; // 300ms

// Text input length limits
export const MAX_BAN_REASON_LENGTH = 500; // Maximum characters for ban reason
export const MAX_TEXTAREA_DEFAULT_LENGTH = 1000; // Default max length for textareas
